export const VERIFY_EMAIL_BEGIN = "VERIFY_EMAIL_BEGIN";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";
